/**
 * Custom hook to manage church language preference
 * Automatically applies the church's language setting from the database
 */

import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { supabase } from '@/lib/supabase'

export function useChurchLanguage() {
  const { i18n } = useTranslation()

  useEffect(() => {
    loadAndApplyChurchLanguage()
  }, [])

  async function loadAndApplyChurchLanguage() {
    try {
      // Get current user's church
      const { data: { user } } = await supabase.auth.getUser()
      if (!user) return

      // Get user's church ID from their profile
      const { data: profile } = await supabase
        .from('profiles')
        .select('church_id')
        .eq('id', user.id)
        .single()

      if (!profile || !profile.church_id) return

      // Load church settings
      const { data: church } = await supabase
        .from('churches')
        .select('settings')
        .eq('id', profile.church_id)
        .single()

      if (church && church.settings) {
        const settings = church.settings as any
        const language = settings.language || 'en'

        // Change language if different from current
        if (i18n.language !== language) {
          await i18n.changeLanguage(language)
        }
      }
    } catch (error) {
      console.error('Error loading church language:', error)
    }
  }

  return { i18n }
}
